export const links = [
  {
    linkName: "Features",
    path: "/features",
  },
  {
    linkName: "Pricing",
    path: "/features",
  },
  {
    linkName: "Contact",
    path: "/features",
  },
  {
    linkName: "Login",
    path: "/login",
  },
];
